// extracted by mini-css-extract-plugin
export default {"node":"PlaceholderNode_node__R94aY","addNode":"PlaceholderNode_addNode__QyuaI"};